<template>
  <div class="Box">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="has-text-weight-bold">
      Informações Principais
    </h2>
    <br />

    <div class="columns">
      <!-- Logo OE -->
      <div class="column is-narrow">
        <div
          class="logo-upload-div"
          :style="{ 'background-image': `url(${previewImage})` }"
          @click="selectImage"
        >
          <b-icon
            icon="camera-retro"
            size="is-large"
            style="position: relative; left: 23px; top: 12px; color: #999"
            v-if="!previewImage"
          ></b-icon>
          <p
            class="has-text-centered"
            style="font-size: 0.8rem; position: relative; top: 6px; color: #999"
            v-if="!previewImage"
          >
            Logo PNG
          </p>
        </div>

        <input
          ref="fileInput"
          type="file"
          @input="pickFile"
          style="display: none;"
          accept="image/png"
        />
      </div>

      <!-- A/O + Nome da OE -->
      <div class="column">
        <b-field>
          <b-field
            :label="
              $parent.$parent.$parent.oe.treatmentPronoun
                ? 'Pronome de tratamento / Nome da OE'
                : ''
            "
            label-position="on-border"
          >
            <b-select
              v-model="$parent.$parent.$parent.oe.treatmentPronoun"
              placeholder="Pronome"
            >
              <option value="">Pronome</option>
              <option value="a">a</option>
              <option value="o">o</option>
            </b-select>

            <b-input
              v-model="$parent.$parent.$parent.oe.name"
              placeholder="Nome da sua OE..."
              expanded
            >
            </b-input>
          </b-field>
        </b-field>

        <!-- Categoria -->
        <b-field
          :label="$parent.$parent.$parent.oe.category ? 'Categoria' : ''"
          label-position="on-border"
          style="margin-top: 1.5rem;"
        >
          <b-select v-model="$parent.$parent.$parent.oe.category" expanded>
            <option value="">Categoria</option>
            <option value="Aerodesign">Aerodesign</option>
            <option value="AIESEC">AIESEC</option>
            <option value="Atlética Universitária">
              Atlética Universitária
            </option>
            <option value="Baja">Baja</option>
            <option value="Barco Solar">Barco Solar</option>
            <option value="Centro Acadêmico">Centro Acadêmico</option>
            <option value="Clube de Consultoria">Clube de Consultoria</option>
            <option value="Clube de Empreendedorismo">
              Clube de Empreendedorismo
            </option>
            <option value="Coletivo">Coletivo</option>
            <option value="Cursos Populares">Cursos Populares</option>
            <option value="Diretório Acadêmico">Diretório Acadêmico</option>
            <option value="Eficiência Energética">Eficiência Energética</option>
            <option value="Empresa Júnior">Empresa Júnior</option>
            <option value="Enactus">Enactus</option>
            <option value="Engenheiros sem Fronteiras">
              Engenheiros sem Fronteiras
            </option>
            <option value="Equipe de Foguetes">Equipe de Foguetes</option>
            <option value="Evento">Evento</option>
            <option value="Feira de Carreiras">Feira de Carreiras</option>
            <option value="Fórmula">Fórmula</option>
            <option value="Grupo de Estudos">Grupo de Estudos</option>
            <option value="Grupo de Extensão">Grupo de Extensão</option>
            <option value="Grupo de Pesquisa">Grupo de Pesquisa</option>
            <option value="IEEE">IEEE</option>
            <option value="Liga Acadêmica">Liga Acadêmica</option>
            <option value="Liga de Mercado Financeiro">
              Liga de Mercado Financeiro
            </option>
            <option value="ONG">ONG</option>
            <option value="PET (Programa de Educação Tutorial)">
              PET (Programa de Educação Tutorial)
            </option>
            <option value="Robótica">Robótica</option>
            <option value="Semana de Curso">Semana de Curso</option>
            <option value="separador" disabled>-------------</option>
            <option value="Outra">Outros Grupos</option>
          </b-select>
        </b-field>
      </div>
    </div>

    <!-- Outra Categoria -->
    <div class="columns" v-show="$parent.$parent.$parent.isAnotherCategory">
      <div class="column">
        <b-field
          :label="
            $parent.$parent.$parent.oe.anotherCategory
              ? 'Qual outro grupo?'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.anotherCategory"
            placeholder="Qual outro grupo?"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- E-mail institucional -->
        <b-field
          :label="
            $parent.$parent.$parent.oe.organizationEmail
              ? 'E-mail institucional'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.organizationEmail"
            placeholder="E-mail institucional"
            expanded
          >
          </b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- Estado -->
        <b-field
          :label="$parent.$parent.$parent.oe.state ? 'UF' : ''"
          label-position="on-border"
        >
          <b-autocomplete
            v-model="$parent.$parent.$parent.oe.state"
            :data="filteredStatesArray"
            :open-on-focus="true"
            :keep-first="true"
            placeholder="UF"
            @select="option => (selected = option)"
          >
            <template slot="empty">
              Sem resultados
            </template>
          </b-autocomplete>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- Cidade -->
        <b-field
          :label="$parent.$parent.$parent.oe.city ? 'Cidade' : ''"
          label-position="on-border"
        >
          <b-autocomplete
            v-model="$parent.$parent.$parent.oe.city"
            :data="filteredCitiesArray"
            :open-on-focus="true"
            :keep-first="true"
            placeholder="Cidade"
            @select="option => (selected = option)"
            :disabled="!isValidState"
          >
            <template slot="empty">
              Sem resultados
            </template>
          </b-autocomplete>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Universidade -->
        <b-field
          :label="$parent.$parent.$parent.oe.university ? 'Universidade' : ''"
          label-position="on-border"
        >
          <b-autocomplete
            v-model="$parent.$parent.$parent.oe.university"
            :data="filteredUniversitiesArray"
            :open-on-focus="true"
            :keep-first="true"
            placeholder="Universidade"
            @select="option => (selected = option)"
            :disabled="!isValidState"
          >
            <template slot="empty">
              Sem resultados
            </template>
          </b-autocomplete>
        </b-field>
      </div>
    </div>

    <div class="columns" v-show="isAnotherUniversity">
      <div class="column">
        <!-- Qual outra universidade? -->
        <b-field
          :label="
            $parent.$parent.$parent.oe.anotherUniversity
              ? 'Qual outra Universidade?'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.anotherUniversity"
            placeholder="Qual outra Universidade?"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns" v-show="isVariousUniversities">
      <div class="column">
        <!-- Quais outras universidades? -->
        <b-field
          :label="
            $parent.$parent.$parent.oe.variousUniversities
              ? 'Quais outras Universidades?'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.variousUniversities"
            placeholder="Quais outras Universidades?"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- OE - Facebook -->
        <b-field
          :label="$parent.$parent.$parent.oe.fanpage ? 'fanpage da OE' : ''"
          label-position="on-border"
        >
          <p class="control">
            <span class="button is-static">facebook.com/</span>
          </p>

          <b-input
            v-model="$parent.$parent.$parent.oe.fanpage"
            placeholder="fanpage da OE"
            expanded
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- OE - Insta -->
        <b-field
          :label="$parent.$parent.$parent.oe.insta ? 'insta da OE' : ''"
          label-position="on-border"
        >
          <p class="control">
            <span class="button is-static">instagram.com/</span>
          </p>
          <b-input
            v-model="$parent.$parent.$parent.oe.insta"
            placeholder="insta da OE"
            expanded
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- OE - LinkedIn -->
        <b-field
          :label="$parent.$parent.$parent.oe.linkedin ? 'linkedin da OE' : ''"
          label-position="on-border"
        >
          <p class="control">
            <span class="button is-static">linkedin.com/company/</span>
          </p>
          <b-input
            v-model="$parent.$parent.$parent.oe.linkedin"
            placeholder="linkedin da OE"
            expanded
          ></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { cidades_por_estado } from "../../../assets/js/cidades-por-estado";
import { estados } from "../../../assets/js/estados";
import { universidades_por_estado } from "../../../assets/js/universidades-por-estado";

export default {
  data() {
    return {
      isLoading: false,
      citiesList: {},
      universitiesList: {},
      statesList: [],
      previewImage: null
    };
  },

  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },

    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = e => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    }
  },

  computed: {
    ...mapGetters(["account"]),

    isAnotherUniversity() {
      return this.$parent.$parent.$parent.oe.university === "Outra";
    },

    isVariousUniversities() {
      return this.$parent.$parent.$parent.oe.university === "Várias";
    },

    filteredStatesArray() {
      return this.statesList.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.$parent.$parent.$parent.oe.state.toLowerCase()) >= 0
        );
      });
    },

    filteredCitiesArray() {
      let filteredCitiesArray = [];
      if (this.isValidState) {
        filteredCitiesArray = this.citiesList[
          this.$parent.$parent.$parent.oe.state
        ].filter(option => {
          return (
            option
              .toString()
              .toLowerCase()
              .indexOf(this.$parent.$parent.$parent.oe.city.toLowerCase()) >= 0
          );
        });
      }
      return filteredCitiesArray;
    },

    filteredUniversitiesArray() {
      let filteredUniversitiesArray = [];
      if (this.isValidState) {
        filteredUniversitiesArray = this.universitiesList[
          this.$parent.$parent.$parent.oe.state
        ].filter(option => {
          return (
            option
              .toString()
              .toLowerCase()
              .indexOf(
                this.$parent.$parent.$parent.oe.university.toLowerCase()
              ) >= 0
          );
        });
      }
      return filteredUniversitiesArray;
    },

    isValidState() {
      return this.statesList.includes(this.$parent.$parent.$parent.oe.state);
    }
  },

  mounted() {
    if (this.account.canCreateOrganization) {
      this.isLoading = false;
      this.citiesList = cidades_por_estado;
      this.universitiesList = universidades_por_estado;
      this.statesList = estados;
    } else if (
      !this.account.canCreateOrganization &&
      !this.account.isOrganizationLeader
    ) {
      this.isLoading = false;
      this.$store
        .dispatch("checkOrganizationApproved")
        .then(res => {
          if (res.data.isOrganizationLeader === true) {
            this.$buefy.dialog.alert({
              title: "OE aprovada!",
              message:
                "Agora, você já pode aproveitar todos os benefícios da plataforma ;)",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$router.push("/organizationprofile"),
              onCancel: () => this.$router.push("/organizationprofile")
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.Box {
  max-width: 800px !important;
  margin: auto;
}
.logo-upload-div {
  width: 96px;
  height: 96px;
  border: 1px solid #999;
  color: #999;
  border-radius: 50%;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.logo-upload-div:hover {
  opacity: 50%;
}
</style>
